export const generale = {
  NomLogiciel: 'OpenCash',
  language: 'fr',
  total: 'Totaux',
  DescriptionLogiciel:
    'Communication bancaire, moyens de paiements, gestion de trésorerie...',
  pdfViewer: {
    Title: 'Aperçu avant impression',
  },
  label_title_liste: 'Liste des Labels',
  ListSmartTags: 'Liste des SmartTags',
  find_smart_tags: 'Recherche un SmartTag par code',
  ListBanque: 'Liste des Banques',
  find_banque: 'Rechercher une banque par code, nom ...',
  find_label: 'Rechercher un label par valeur de rubrique...',
  lecture_seule: ' (Lecture seule)',
  'List of companies': 'Liste des sociétés',
  State: 'Etat',
  None: 'Aucun',
  Name: 'Nom',
  Code: 'Code',
  vue_simple: 'Vue simple',
  vue_detail: 'Vue détaillée',

  update_timestamp: 'Date de modification',
  Edit: 'Éditer',
  Delete: 'Supprimer',
  Initialise: 'Initialiser',
  aSupprimer: 'A supprimer',
  Enter: 'Détail',
  Admin: 'Administrer',
  Import: 'Importer',
  Export: 'Exporter',
  New: 'Nouveau ',
  Element: 'élément',
  Elements: 'éléments',
  View: 'Voir',
  visu: 'Visualiser',
  error_required: '* Ce champ est obligatoire.',
  error_maxLength: '* Le nombre des caractères maximal autorisés est {{max}}.',
  error_minLength: '* Le nombre des caractères minimal autorisés est {{min}}.',
  Json_params: 'Visualiser paramètre json',
  Json: 'Visualiser json',
  Json_return: 'Visualiser réponse json',
  down_Json_params: 'Télécharger paramètre json',
  down_Json_return: 'Télécharger réponse json',
  History: 'Historique',
  Statement: 'Relevé',
  Back: 'Annuler',
  Selection: 'Sélection',
  next: 'Suivant',
  prev: 'Précédent',

  Ok: 'Ok',
  Print: 'Imprimer',
  Entity: 'Entité',
  refresh: 'Rafraîchir',
  'New company': 'Nouvelle société',
  'Fax number': 'N* Fax',
  'Phone number': 'N* Téléphone',
  'Legal informations': 'Informations légales',
  Address: 'Adresse',
  Administraion: 'Administraion',
  'Country code': 'Pays',
  'Closing date': 'Date de clôture',
  Duplicate: 'Dupliquer',
  Download: 'Télécharger',
  Restart: 'Relancer',
  Unlock: 'Declôturer',
  'Upload image': 'Télécharger une image',
  'Update company successfully': 'Mettre à jour la société avec succès',
  'Update company failed': 'Échec de la mise à jour de la société',
  Save: 'Enregistrer',
  'Company detail': 'Détail de la société',
  '4Eyes State': '4Eyes etat',
  'Liste des lots': 'Gestion des lots',
  Emetteur: 'Emetteur',
  'N remise': '# remise',
  Montant: 'Montant',
  Comment: 'Commentaire',
  Devise: 'Devise',
  pour1: 'Pour 1',
  Taux: 'Taux',
  Add: 'Ajouter',
  Reissue: 'Réemettre',
  Origine: 'Origine',
  Statut: 'Statut',
  Confirmation: 'Confirmation',
  Action_validation: "Validation de l'action",
  yes: 'Oui',
  no: 'Non',
  date_validation: "Date de l'action",
  Message_validation: "Voulez-vous valider l'action : ",
  remplace_document: 'Voulez-vous remplacer le document ? ',
  Valider: 'Valider',
  'Valider-New': 'Valider et nouveau',
  nextinvoicebutton: 'Remises suivantes',
  ValidDelete: 'Valider suppression',
  Fermer: 'Fermer',
  'Recherche grp tiers': 'Rechercher un groupe de tiers par code, nom ..',
  'Groupe de tiers': 'groupe de tiers',
  details: 'détails',
  Suppression: 'Voulez-vous supprimer ',
  Refuser: 'Désirez-vous refuser ce message ',
  Signer: 'Désirez-vous signer ce message ',
  Confirmer: 'Confirmer',
  Annuler: 'Annuler',
  Creer: 'Créer',
  RechercherSociete: 'Rechercher une société par code, nom ...',
  ComboEtat: '- Etat -',
  ComboFlux: '- Flux -',
  ComboFichier: '- Type Fichier -',
  ComboOrigine: '- Origine -',
  ComboStatut: '- Statut -',
  ComboGrpTiers: '- Groupe de tiers -',
  Signature: 'Signature',
  'Nb Operations': 'Nb',
  Rappro: 'Rapprochement',
  RechercheLot: 'Recherche un lot par numéro de lot, numéro de devise ...',
  RechercheTiers:
    'Rechercher un tiers par code, nom, numéro de compte, SIREN ..',
  Groupe: 'Groupe',
  'New tiers': "Création d'un nouveau tiers",
  'Details tiers': 'Fiche du tiers',
  General: 'Général',
  IBAN: 'Coordonnées bancaires',
  'Adresse tiers': 'Adresse du tiers',
  'Banque inter': 'Banque intermédiaire',
  Expand: 'Etendre',
  Nom: 'Nom',
  Prenom: 'Prénom',
  Naissance: 'Date de naissance',
  PNaissance: 'Pays de naissance',
  VNaissance: 'Ville de naissance',
  Company: 'Société',
  Rules: 'Règles',
  NCompte: 'N° de compte',
  AutoEmetteur: 'Autorisé compte émetteur',
  AutoTiers: 'Autorisé compte tiers',
  'Fiche du compte': 'Fiche du compte',
  'Informations complémentaires': 'Informations complémentaires',
  Collapse: 'Réduire',
  Action: 'Actions',
  NoData: 'Pas de données disponibles',
  Loading: 'Chargement en cours',
  'n° mobile': 'N° mobile',
  prenom: 'Prénom',
  nom: 'Nom',
  etat_user: 'Etat user',
  Etat_user_entite: 'User entity state',
  'N° demande': '#',
  'Type de demande': 'Type de demande',
  'Validation date': 'Validation / Refus',
  'Request type': 'type de demande',
  'Short name': 'nom (court)',
  valideur: 'validator',
  'Request date': 'date demande',
  Applicant: 'demandeur',
  titleChange: 'Changement de Filiale ou de Périmètre',
  AdminChange: 'Changement de Clients',
  listUserClientDispo: 'Client',
  listUserAdminDispo: 'Admin',
  Perim: 'Rechercher un périmètre',
  Fil: 'Rechercher une filiale',
  scope: 'Périmètre',
  entity: 'Filiale',
  copied: 'Copier',
  coller: 'Coller',
  search_user: "Rechercher un nom d'utilisateur",
  account_management: {
    account_list: 'Liste des comptes bancaires',
    search_txt:
      'Rechercher un compte par code, nom, numéro de compte, code société, nom société...',
    account_detail: 'Visualisation du relevé de compte',
    operation: 'opérations',
    search_detail:
      'Rechercher une opération par reférence , code , libellé ...',
  },
  bool: {
    yes: 'Oui',
    no: 'Non',
  },
  calendar: {
    today: "Aujourd'hui",
    yesterday: 'Hier',
    tomorrow: 'Demain',
    last7Days: '7 derniers jours',
    week: 'Cette semaine',
    mounth: 'Ce mois-ci',
    lastMonth: 'Mois dernier',
    last30days: '30 derniers jours',
    year: 'Cette année',
    lastYear: 'Année dernière',
    mon: 'Lun',
    tue: 'Mar',
    we: 'Mer',
    thu: 'Jeu',
    fri: 'Ven',
    sa: 'Sam',
    sun: 'Dim',
    formatdate: 'JJ/MM/AAAA',
    clear: 'Enlever',
    last_tree_mounth: 'Dernier trimestre',
    current_tree_mounth: 'Trimestre en cours',
    first_quarter: 'T1',
    second_quarter: 'T2',
    third_quarter: 'T3',
    fourth_quarter: 'T4',
    first_semestre: 'S1',
    second_semestre: 'S2',
    placeholder: 'JJ/MM/AAAA - JJ/MM/AAAA',
    placeholder_dateMonth: 'JJ/MM',
    placeholder_yearOnly: 'AAAA - AAAA',
    // Full Calendar specific translations
    fullCalendarTitle: 'Calendrier Complet',
    month: 'Mois',
    day: 'Jour',
    addEvent: 'Ajouter un Événement',
    editEvent: "Modifier l'Événement",
    saveEvent: "Enregistrer l'Événement",
    updateEvent: "Mettre à jour l'Événement",
    eventTitle: "Titre de l'Événement",
    eventDescription: "Description de l'Événement",
    eventTitlePlaceholder: "Saisir le titre de l'événement...",
    eventDescriptionPlaceholder:
      "Saisir la description de l'événement (optionnel)...",
    confirmDelete:
      'Êtes-vous sûr de vouloir supprimer l\'événement "{{title}}" ?',
    back: 'Retour',
  },
  treepicker: {
    placeholder: 'Recherche',
  },
  data_grid: {
    start: 'Min',
    end: 'Max',
    noDataToExport: 'Aucune donnée à exporter',
    pagination: 'Résultats par page',
    indexpagination: 'sur',
    showpagination: 'Afficher',
    diff_showpagination: 'Showing',
    diffindex: 'of',
  },
  Pays: 'Pays',
  login: {
    hometitle: 'OpenCash | Authentification',
    login: 'Login',
    forgotpassword: 'Mot de passe perdu ? ',
    reset: 'Réinitialiser',
    saveCredentials: 'Mémoriser',
    loginFailed: 'Identification erronée. Merci de réessayer',
    signin: 'Connexion',
    username_required: 'Email obligatoire',
    password_required: 'Mot de passe obligatoire',
    language: 'Préférence de langue',
    enter_email: 'Saisissez votre email',
    reset_password: 'Mot de passe',
    confirm_password: 'Confirmation de mot de passe',
    pwd: 'Mot de passe',
    back_to: 'Retour au',
    confirm_error: 'Le mot de passe ne correspondent pas',
    reset_password_label: 'Réinitialiser mot de passe',
    update_pwd_label: 'Mise à jour mot de passe',
    info_pwd_label:
      'Votre mot de passe est expiré, vous devez saisir un nouveau mot de passe',
    current_pwd: 'Mot de passe actuel',
    new_pwd: 'Nouveau mot de passe',
    confirm_new_pwd: 'Confirmer le nouveau mot de passe',
    send_mail: 'Envoyer un e-mail',
    update: 'Changer le mot de passe',
    current_password_required: 'Le mot de passe actuel est requis',
    password_min_length: 'Le mot de passe doit contenir au moins 8 caractères',
    password_must_match: 'Les mots de passe ne correspondent pas',
    password_updated_success: 'Votre mot de passe a été mis à jour avec succès',
    generic_error: 'Une erreur est survenue, veuillez réessayer',
    updating: 'Mise à jour en cours...',
  },
  creation_date: 'Date de création',
  execution_date: "Date d'éxécution",

  composant_document: {
    add_title: "Création d'un nouveau document",
    edit_title: 'Fiche document',
    txt_errorfile: 'Tous les champs sont obligatoires sauf la date de fin',
  },
  notification: {
    title: 'Notifications',
    empty: 'Notifications vide',
    show_not_seen: 'Afficher uniquement les non lues',
    mark_as_read: 'Marquer comme lu',
    clear_all: 'Effacer tout',
  },
  dashboard: {
    parapheur: {
      top: 'Mon parapheur',
      bottom: 'lots à signer',
    },
    lot: {
      top: 'Gestion des lots',
      bottom: 'lot en attente',
    },
    active_user: {
      top: 'Utilisateurs',
      bottom: 'utilisateurs actifs',
    },
    'active_acount/disable_acount': {
      top: 'Compte émetteurs',
      bottom: 'actifs / inactifs',
    },
    StatFlux: 'Comparatif des flux',
  },
  component_document: {
    titleImportfile: 'Document',
    importfile: 'Import fichier ...',
    btnNameEdit: 'Fiche Document',
    btnNameAdd: 'Document',
    docName: 'Nom document',
    docType: 'Type de document',
    docEtat: ' Etat',
    dateEnd: 'Date de fin',
    dateStart: 'Date de début',
    erroValidationChamp:
      'Tous les champs sont obligatoires sauf la date de fin',
    errorFormatfile: 'Veuillez importer un fichier pdf',
    titleError: 'Erreur',
    placeholderDocName: '- Si vide nom chargé automatiquement -',
    nbFileAccepted: 'Un fichier PDF accepté',
    other_file_type: 'Veuillez insérer un fichier de type pdf',
  },
  idleModal: {
    title: "Votre session est sur le point d'expirer",
    expiration:
      "Votre session est sur le point d'expirer. Vous serez automatiquement déconnecté.",
    question: 'Souhaitez-vous rester connecté ?',
    remaining: 'Vous avez {{remainingTime}} secondes pour rester connecté',
    button: 'Rester connecté',
  },
  datagrid: {
    pageText: 'Page',
    ofText: ' sur ',
    perPageText: 'Résultat par page',
    showingText: 'Afficher ',
    clearAll: 'Supprimer tous les filtres',
    clear: 'Supprimer le filtre',
    showFilteringRow: 'Afficher les filtres',
    hideFilteringRow: 'Ne pas afficher les filtres',
    enable: 'Activé',
    disable: 'Désactivé',
    sortAsc: 'Tri ascendant',
    sortDesc: 'Tri descendant',
    unsort: 'Pas de tri',
    group: 'Grouper',
    ungroup: 'Dégrouper',
    lockStart: 'Figer au début',
    lockEnd: 'Figer à la fin',
    unlock: 'Ne pas figer',
    columns: 'Colonnes',
    autoresizeThisColumn: 'Redimensionner cette colonne',
    autoresizeAllColumns: 'Redimensionner toutes les colonnes',
    autoSizeToFit: 'Adapter automatiquement',
    contains: 'Contient',
    startsWith: 'Commence par',
    endsWith: 'Finit par',
    notContains: 'Ne contient pas',
    inlist: 'Est dans la liste',
    notinlist: "N'est pas dans la liste",
    neq: 'Différent de',
    inrange: 'Dans la plage',
    notinrange: "N'est pas dans la plage",
    eq: 'Egal à',
    notEmpty: 'Non vide',
    empty: 'Est vide',
    lt: 'Inférieur à',
    lte: 'Inférieur ou égal à',
    gt: 'Supérieur à',
    gte: 'Supérieur ou égal à',
    before: 'Inférieur à',
    beforeOrOn: 'Inférieur ou égal à',
    afterOrOn: 'Supérieur ou égal à',
    after: 'Supérieur à',
    start: 'De',
    end: 'A',
    dragHeaderToGroup: 'Faites glisser ici pour grouper',
    noRecords: 'string',
    calendartodayButtonText: "Aujourd'hui",
    calendarclearButtonText: 'Effacer',
    calendarokButtonText: 'Valider',
    calendarcancelButtonText: 'Annuler',
  },
  valid: 'Valider',
  selection: '- Sélectionner -',
  success: 'Succès',
  error: 'Erreur',
  message_error_rib:
    'Veuillez joindre un document de type RIB pour le nouveau compte',
  code_society: 'Société',
}

